import { jsx as t } from "react/jsx-runtime";
import { Body as o } from "@vds-core/typography";
import { ColorTokens as e } from "@vds-tokens/color";
import { TrailingTooltip as i } from "@vds-core/tooltips";
var r = function r(_r) {
  var l = _r.surface,
    p = _r.viewport,
    s = _r.children,
    n = _r.tooltip,
    a = _r.primitive,
    c = n && (n.title || n.children),
    d = e.elements.secondary["on".concat(l)].value,
    m = "mobile" === p;
  return c ? t("span", {
    "data-testid": "test-tooltipevent",
    onClick: function onClick(t) {
      t && t.stopPropagation();
    },
    children: t(i, Object.assign({}, n, {
      typographyType: "body",
      typographySize: m ? "small" : "large",
      typographyColor: d,
      viewport: p,
      iconFillColor: "secondary",
      surface: l,
      tooltipTitle: n && n.title ? n.title : void 0,
      tooltipContent: n && n.children ? n.children : void 0,
      tooltipCloseButtonText: n && n.closeButtonText ? n.closeButtonText : void 0,
      tooltipSize: m ? "small" : "medium",
      typographyPrimitive: a,
      children: s
    }))
  }) : t(o, {
    color: d,
    size: m ? "small" : "large",
    viewport: p,
    primitive: a,
    children: s
  });
};
r.defaultProps = {
  surface: "light",
  primitive: "p",
  viewport: "desktop"
}, r.displayName = "ListGroupItemSubtitle";
export { r as default };